import { render } from "./StudentDatatable.vue?vue&type=template&id=de73f310"
import script from "./StudentDatatable.vue?vue&type=script&lang=js"
export * from "./StudentDatatable.vue?vue&type=script&lang=js"

import "./StudentDatatable.vue?vue&type=style&index=0&id=de73f310&lang=scss"

import exportComponent from "/opt/referents/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__